// Pure rules: given a player's in-game state, can they take a given action?
//
// One place both the client (to enable/disable the turn action bar) and the
// server (to validate) can ask "is this action available?". Costs are read from
// the config tables (the single source of truth), so this never hard-codes a
// number a rule already owns.
import { FORTRESS_CARDS_CONFIG } from "../config/fortress.js";
import { canAffordWith, substitutionsFor } from "../effects/payment.js";
/** True if `bank` covers every component of `cost` under the player's
 * payment substitutions (Conversion Treadmill / Transmutation Bench) — the
 * same `canAffordWith` the server validates with, so client and server agree. */
function affords(bank, cost, state) {
    return canAffordWith(bank, cost, substitutionsFor(state.fortressCards));
}
/**
 * Compute whether `action` (a core action) is available to a player in `state`.
 *
 * Only `cycle_market` is gated for now — you can cycle a Fortress out of a market
 * row only if you can afford at least one row's cycle cost (1 Food today). The
 * other core actions default to allowed until their own rules are added.
 */
export function canPerformAction(action, state, config = {}) {
    switch (action) {
        case "cycle_market": {
            const fc = config.fortressCards ?? FORTRESS_CARDS_CONFIG;
            // Available if the player can pay for cycling in either market row.
            const affordable = affords(state.bank, fc.cycleCostPerRegularCard, state) ||
                affords(state.bank, fc.cycleCostPerWinCard, state);
            return affordable
                ? { allowed: true }
                : { allowed: false, reason: "Need at least 1 Food to cycle a card" };
        }
        // Not yet gated — each gains its own rule as the action flows are built.
        case "construct_building":
        case "construct_bridge":
        case "implement_fortress":
        case "aim_barracks":
            return { allowed: true };
        default:
            // Exhaustiveness guard: adding an ActionKind without a case fails to compile.
            return assertNever(action);
    }
}
function assertNever(value) {
    throw new Error(`canPerformAction: unhandled action kind "${String(value)}"`);
}
//# sourceMappingURL=actions.js.map